// [⑦ 3-1] 단체 통화 숨김 스위치 (개발 모드 또는 localStorage 플래그로 활성화)
// 콘솔에서 켜기: window.localStorage.setItem('moowoo_dev_group_call', '1') / 끄기: removeItem
export function isGroupCallEnabled() {
  // 단체 통화 전원 공개(2026-10-28). 다시 숨기려면 이 줄을 이전 판정(DEV 또는 localStorage 'moowoo_dev_group_call' === '1')으로 되돌린다.
  return true;
}
